import React from "react";
import Link from "next/link";
import { format } from "date-fns";
export const BlogPostPreview = ({ data }) => {
  return (
    <div className="mb-4 border-b border-dashed border-block-light">
      <Link href={`${data.uri}`} className="block" >

        <h2 className="hover:text-primary transition-colors text-3xl font-light">
          {data.title}
        </h2>

      </Link>
      <div className="flex items-center mt-2">
        {data.categories.map((node, index) => {
          return (
            <Link
              href={`/category/${node.slug}`}
              key={`category-link-${index}`}
              className="mr-3 bg-block-light hover:bg-primary transition-colors font-bold text-sm px-1"
            >
              {node.name}
            </Link>
          );
        })}
        <span className="mr-3 text-sm text-muted">{data.author_name}</span>
        <span className="mr-3 transition-colors text-sm text-muted">
          {data.post_date}
        </span>
      </div>
      <div className="flex mt-4 pb-4">
        {data?.featured_image_url && (
          <div className="flex-shrink-0 mr-4 w-40 h-40">
            <img
              width="150"
              height="150"
              src={data.featured_image_url}
              alt={data.title}
              title={data.title}
              className="object-cover h-full w-full"
            />
          </div>
        )}
        <div>
          <p className="text-sm mb-4">
            {data.excerpt}
          </p>
          <Link
            href={`${data.uri}`}
            className="py-2 px-4 inline-flex uppercase text-sm font-bold bg-block hover:bg-primary transition-colors">

            Read more

          </Link>
        </div>
      </div>
    </div>
  );
};
